import moment from "moment";

export const responseDate = (value) => value && moment.utc(value).isValid() ? moment.utc(value).format("MMM D, YYYY") : "—";
const ordered = (items, order, key) => order ? String(order).split(",").map((id) => items.find((item) => String(item[key]) === id.trim() || String(item.type) === id.trim())).filter(Boolean) : items;

export const responseModel = (survey, result) => {
  const definition = result.definition_snapshot || survey || {};
  const context = { ...result.reservation, ...result.context_snapshot };
  return {
    definition, context,
    guestName: [context.first_name, context.last_name].filter(Boolean).join(" ") || "Guest",
    questions: ordered(definition.questions || [], definition.question_order, "survey_question_id").filter((q) => !q.deleted),
    submitted: result.created_at && moment.utc(result.created_at).isValid() ? moment.utc(result.created_at).local().format("MMM D, YYYY h:mm A") : "—",
  };
};

export const responseAnswers = (result, questionId) => (result.answers || []).filter((a) => String(a.survey_question_id) === String(questionId)).flatMap((a) =>
  Array.isArray(a.answer) && a.answer.length ? a.answer.map((value, i) => ({ ...a, answer: value, custom_answer: i === 0 ? a.custom_answer : "" })) : [a]);

export const responseOptions = (question) => ordered((question.question_options || []).filter((o) => !o.deleted), question.option_order, "survey_question_option_id");
